import React from 'react';
import { Link } from 'react-router-dom';
import StaticPageLayout from '../components/Layout/StaticPageLayout';

const Returns = () => {
  return (
    <StaticPageLayout title="Returns &amp; Refunds" draftNotice>
      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Return Window</h2>
        <p>[TODO: confirm the number of days customers have to request a return or exchange after delivery].</p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Condition of Items</h2>
        <p>
          Items are typically expected to be unused, unworn, and in their original packaging with tags attached
          to be eligible for return. [TODO: confirm any exceptions].
        </p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Non-Returnable Items</h2>
        <p>
          Some items, such as pierced earrings, are commonly excluded from returns for hygiene reasons.
          [TODO: confirm the final list of non-returnable items].
        </p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Refunds</h2>
        <p>
          Approved refunds are issued to your original payment method. [TODO: confirm typical refund processing time].
        </p>
      </div>

      <p className="text-sm text-gray-500">
        To start a return, <Link to="/contact" className="text-blue-600 hover:underline">contact us</Link> with your order number.
      </p>
    </StaticPageLayout>
  );
};

export default Returns;
